var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 771,
    height: 445,
    viewBox: "0 0 771 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 192,
    r: 7,
    fill: "#6ECD92"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 373,
    r: 6,
    fill: "#78A7C2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 438,
    r: 7,
    fill: "#FA7B7A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699,
    cy: 308,
    r: 7,
    fill: "#CB9CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 52.5,
    r: 17.5,
    fill: "#FFDFC0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.5,
    cy: 349.5,
    r: 17.5,
    fill: "#9ACCF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.5,
    cy: 17.5,
    r: 17.5,
    fill: "#F3DBFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.bd7ab721952e0a46132ad718a311ed10.svg";
export { ForwardRef as ReactComponent };